import { render, staticRenderFns } from "./RegistrationInfoEdit.vue?vue&type=template&id=284cf5aa&scoped=true&"
import script from "./RegistrationInfoEdit.vue?vue&type=script&lang=js&"
export * from "./RegistrationInfoEdit.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationInfoEdit.vue?vue&type=style&index=0&id=284cf5aa&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284cf5aa",
  null
  
)

export default component.exports